import React from "react";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import { ClipboardCheck, Plus } from "lucide-react";
import { toast } from "sonner";
import api from "../lib/api";
import { useFirma } from "../context/FirmaContext";

export const useTerCheck = (ospiteId) => useQuery({ queryKey: ["ter-checklist", ospiteId], enabled: !!ospiteId, queryFn: async () => (await api.get("/terapie/checklist", { params: { ospite_id: ospiteId } })).data });
export const normOra = (o) => { const m = String(o || "").trim().match(/^(\d{1,2})[:.](\d{2})$/); return m ? `${m[1].padStart(2, "0")}:${m[2]}` : ""; };

export function CheckListBtn({ t, kind, ospiteId, ora }) {
  const qc = useQueryClient();
  const { canSign, signerName } = useFirma();
  const { data: list = [] } = useTerCheck(ospiteId);
  if (!t?.id || t.tipo === "bisogno") return null;
  const hm = normOra(ora);
  const it = list.find((x) => x.terapia_id === t.id);
  const on = !!it && (!hm || (it.ore || []).includes(hm));
  const chi = on && hm ? it.ore_info?.[hm]?.operatore : it?.operatore;
  const lbl = `${t.farmaco}${hm ? ` delle ${hm}` : ""}`;
  const tid = `ter-cl-${kind}-${t.id}${hm ? `-${hm.replace(":", "")}` : ""}`;
  const toggle = async (e) => {
    e.stopPropagation();
    if (!canSign) { toast.error("Sblocca con la Firma Rapida (PIN)"); return; }
    if (on && !window.confirm(`Togliere ${lbl} dalla Check-list sanitaria?`)) return;
    try {
      if (on) await api.delete(`/terapie/checklist/${t.id}`, { params: { kind, ...(hm ? { ora: hm } : {}) } });
      else await api.post("/terapie/checklist", { terapia_id: t.id, kind, operatore: signerName, ...(hm ? { ora: hm } : {}) });
      ["ter-checklist", "checklist-oggi", "nav-badges", "inf-checklist", "inf-checklist-riep"].forEach((k) => qc.invalidateQueries({ queryKey: [k] }));
      toast.success(on ? `${lbl} tolto dalla Check-list` : `${lbl} aggiunto alla Check-list sanitaria (in ritardo dopo 2 ore dall'orario)`);
    } catch (err) { toast.error(err?.response?.data?.detail || "Errore"); }
  };
  return (
    <button type="button" onClick={toggle} data-testid={tid} title={on ? `In Check-list${chi ? ` (aggiunto da ${chi})` : ""}: clic per togliere` : `Aggiungi ${hm ? `l'orario ${hm}` : "il farmaco"} alla Check-list sanitaria`}
      className={`shrink-0 inline-flex items-center gap-0.5 rounded-full border px-1.5 py-0.5 text-[9px] font-bold uppercase transition-colors ${on ? "bg-sky-600 text-white border-sky-600 hover:bg-sky-700" : "bg-white text-sky-700 border-sky-200 hover:bg-sky-50"}`}>
      {on ? <><ClipboardCheck size={10} /> In check-list</> : <><Plus size={10} /> Check-list</>}
    </button>
  );
}
